<div *ngIf="selecionado">
  <app-pecas-atendidas-cadastro
    [model]="selecionado"
    (buscar)="buscar($event)"
    [state]="state">
  </app-pecas-atendidas-cadastro>
</div>
<div *ngIf="!selecionado">
  <app-pecas-atendidas-filtro [filtros]="filtros"></app-pecas-atendidas-filtro>
  <app-pecas-atendidas-lista
    [filtros]="filtros"
    (exibir)="selecionar($event)"
    (definirFiltro)="definirFiltro()">
  </app-pecas-atendidas-lista>
</div>